import { memo } from 'react';

import { useMe } from 'com/App/WithMe';
import { TEditorConfig } from 'com/Editor/Editor/interface';
import { FormCheckbox, FormGroup, FormInput } from 'core/ui/Form';

const UserEditorForm: TEditorConfig<null, TUser, TUserUpdate>['Form'] = ({
  editingEntity: editingUser,
  onChange,
}) => {
  const me = useMe();
  const uid = 'uid' in editingUser ? editingUser.uid : null;

  return (
    <FormGroup title="Your profile">
      <FormInput
        placeholder="Login"
        name="login"
        value={editingUser.login}
        disabled={!me?.isAdmin}
        onChange={onChange}
      />
      <FormInput
        placeholder="Email"
        name="email"
        value={editingUser.email ?? ''}
        onChange={onChange}
      />
      {(!me?.isAdmin || me.uid === uid) && (
        <FormInput
          placeholder="Old password"
          name="oldPassword"
          type="password"
          value={editingUser.oldPassword}
          onChange={onChange}
        />
      )}
      <FormInput
        placeholder="New password"
        name="newPassword"
        type="password"
        value={editingUser.newPassword}
        onChange={onChange}
      />
      {me?.isAdmin && (
        <FormCheckbox
          name="isAdmin"
          label="Is admin"
          checked={editingUser.isAdmin}
          disabled={me.uid === uid}
          onChange={onChange}
        />
      )}
    </FormGroup>
  );
};

export default memo(UserEditorForm);
